import { createFileRoute } from '@tanstack/react-router';

import { CompareOverview } from '../order/compare/overview/CompareOverview';

export const Route = createFileRoute('/_app/compare')({
    component: CompareOverview,
});
